export default class CartTotals {
  total!: number;
  deposit!: number;
  grandTotal!: number;
  taxes!: {
    total: number;
    data: [];
  };
  fees!: {
    total: number;
    data: [];
  };

  taxesAndFees!: number;

  constructor(data?: Dict) {
    if (!data || !data.success || !data.data) {
      return;
    }

    const raw = data.data;
    this.total = raw.total;
    this.deposit = raw.deposit;
    this.grandTotal = raw.grandTotal;
    this.taxes = raw.taxes;
    this.fees = raw.fees;
    this.taxesAndFees = this.taxes.total + this.fees.total;
  }
}
